import { observer } from 'mobx-react-lite';

import style from './ProgressBar.module.scss';

type ProgressBar = {
  title?: string;
  topProgress?: string;
  rightProgress?: string;
  leftProgress?: string;
  width: number;
};

export const ProgressBar = observer<ProgressBar>(
  ({ title, topProgress, rightProgress, width, leftProgress }) => (
    <div className={style['progressBar-params']}>
      {leftProgress && (
        <div className={style['progressBar-params__lv']}>{leftProgress}</div>
      )}
      <div className={style['progressBar-progbar']}>
        {(topProgress || title) && (
          <div className={style['progressBar-header']}>
            <span>{title}</span>
            <span>{topProgress}</span>
          </div>
        )}
        <div className={style['progressBar__wrap']}>
          <div
            className={style['progressBar-progbar__line']}
            style={{ width: `${width}%` }}
          ></div>
        </div>
      </div>
      {rightProgress && (
        <div className={style['progressBar-params__lv']}>{rightProgress}</div>
      )}
    </div>
  ),
);
